import * as types from './types'
import { TradeDetailLookups, TradeOverview } from './reducer'

export const setTradeOverview = (payload: TradeOverview) => ({
  type: types.SET_TRADE_OVERVIEW,
  payload,
})

export const setTradeDetailLookups = (payload: TradeDetailLookups) => ({
  type: types.SET_TRADE_DETAIL_LOOKUPS,
  payload,
})
